import React from 'react'
import AdmStudentMessage from '../../components/AdminTabs/AdminStudentMessage/AdmStudentMessage'

const StudentMessage = () => {
  return (
    <div>
        <AdmStudentMessage />
    </div>
  )
}

export default StudentMessage